var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCrossRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#df3c3f",
    d: "M7 8.581l-1.838 1.851a.337.337 0 0 1-.479 0L3.568 9.314a.336.336 0 0 1 0-.48L5.419 7 3.568 5.162a.337.337 0 0 1 0-.479l1.118-1.118a.336.336 0 0 1 .48 0L7 5.42l1.837-1.851a.337.337 0 0 1 .48 0l1.118 1.118a.336.336 0 0 1 0 .48L8.58 7l1.851 1.837a.337.337 0 0 1 0 .48l-1.118 1.115a.336.336 0 0 1-.48 0l-1.833-1.85L7 8.58zM14 7c0-3.86-3.14-7-7-7S0 3.14 0 7s3.14 7 7 7 7-3.14 7-7z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCrossRed);
export default __webpack_public_path__ + "static/media/icon_cross_red.fd90885a.svg";
export { ForwardRef as ReactComponent };